import { PrimaryIconButton } from "components";
import TrashVector from "../../../assets/img/trashVector.svg";

const PrimaryDeleteButton =({ onClick, tooltipTitle, disabled, loading, ...rest })=> {
  return (
    <PrimaryIconButton
      icon={<img src={TrashVector} alt="update-icon" />}
      onClick={onClick}
      tooltipTitle={tooltipTitle}
      disabled={disabled}
      loading={loading}
      {...rest}
    />
  );
};

export default PrimaryDeleteButton;
